import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import config from '../../config/config';

// https://redux-toolkit.js.org/rtk-query/usage/examples#authentication
const baseQuery = () => fetchBaseQuery({
  baseUrl: config().apiUrl,
  credentials: 'same-origin',
  prepareHeaders: (headers, { getState }) => {
    // By default, if we have a token in the store,
    // let's use that for authenticated requests
    const token = getState().auth.accessToken;
    headers.set('x-movementx-client', 'react');
    if (token) headers.set('authorization', `Bearer ${token}`);
    const deviceToken = getState().auth.deviceToken;
    if (deviceToken) headers.set('x-movementx-device', deviceToken);
    return headers;
  },
});

export default baseQuery;
